import React from "react";
import ParseFloat from "../../../utils/ParseFloat";
import { getItemNames } from "../../../utils/GetItemsName";

export default function ItemVariationView(props: any) {
  return (
    <>
      <div className="chooseVariation w-full new-chooseVariation">
        <label
          htmlFor={props.id}
          className="flex justify-between items-center w-full cursor-pointer"
        >
          <div className="flex items-start gap-3">
            <div className="variation_option textMd">
              {props.itemName && (
                <p className="font-bold subitem-color">{props.itemName}</p>
              )}
              {props.price && (
                <p className="font-normal text-[#4B4B4B]">{ParseFloat(props.price)}</p>
              )}
            </div>
          </div>

          <input
            type="radio"
            defaultChecked={props.selectedId === props.id}
            id={props.id}
            name="variation"
            onChange={props.onchange}
            className="w-5 h-5 accent-black shrink-0"
          />
        </label>
      </div>
    </>
  );
}
